var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _vm.devicePrice.banner
            ? _c(
                "div",
                [_c("ob1-tag", { attrs: { label: _vm.devicePrice.banner } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.devicePrice.promotion
            ? _c("promo-prix-terminal", {
                staticClass: "mt-1",
                attrs: {
                  "promo-label": _vm.devicePrice.promotion.label,
                  "promo-end-date": _vm.devicePrice.promotion.endDate,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("device-price", {
            staticClass: "d-block",
            attrs: {
              "multiple-price": _vm.devicePrice.price.multiplePrice,
              "total-price-with-promo":
                _vm.devicePrice.price.totalPriceWithPromo,
              "total-price-without-promo":
                _vm.devicePrice.price.totalPriceWithoutPromo,
              "monthly-amount-in-cents": _vm.devicePrice.price.monthlyPayment
                ? _vm.devicePrice.price.monthlyPayment.monthlyAmountInCents
                : null,
              "monthly-duration": _vm.devicePrice.price.monthlyPayment
                ? _vm.devicePrice.price.monthlyPayment.duration
                : null,
              "taeg-rate": _vm.devicePrice.price.monthlyPayment
                ? _vm.devicePrice.price.monthlyPayment.taegRate
                : null,
              "generic-label": _vm.devicePrice.price.monthlyPayment
                ? _vm.devicePrice.price.monthlyPayment.genericLabel
                : null,
              "loan-rate-zero-label": _vm.getLoanRateZeroLabel(
                _vm.devicePrice.price
              ),
              "is-cents-format": true,
              "is-price-inversion-enabled":
                _vm.isPriceInversionEnabledForDevice(_vm.devicePrice.price),
            },
          }),
          _vm._v(" "),
          _vm.devicePrice.price.paymentInfoLabel
            ? _c("cb4x-pxf-mention", {
                attrs: {
                  "payment-info-detail":
                    _vm.devicePrice.price.paymentInfoLabel.detail,
                  "link-label": _vm.devicePrice.paymentSolutionsDto.linkLabel,
                  "modal-id": "popin-pxf-4xcb",
                  "is-from-mobile-detail": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("pxf-cb4x-modal", {
            attrs: {
              "modal-id": "popin-pxf-4xcb",
              "display-cb4x": _vm.devicePrice.price.cb4xAvailable,
              "display-pxf": _vm.devicePrice.price.pxfAvailable,
            },
            scopedSlots: _vm._u(
              [
                _vm.devicePrice.price.cb4xAvailable
                  ? {
                      key: "cb4x-content",
                      fn: function () {
                        return [
                          _vm.fundingDetails.cb4xPopin.withFees
                            ? _c("paying-detail-cb4x-modal-content", {
                                attrs: {
                                  "modal-id": "popin-pxf-4xcb",
                                  "oney-merchant-guid":
                                    _vm.fundingDetails.cb4xPopin
                                      .oneyMerchantGuid,
                                  "oney-widget-src":
                                    _vm.fundingDetails.oneyWidgetSrc,
                                  "counter-delay":
                                    _vm.fundingDetails.counterDelay,
                                  amount:
                                    _vm.devicePrice.price.totalPriceWithPromo /
                                    100,
                                  "header-block":
                                    _vm.fundingDetails.cb4xPopin.headerBlock,
                                  "payment-example-block":
                                    _vm.fundingDetails.cb4xPopin
                                      .paymentExampleBlock,
                                  "how-to-benefit":
                                    _vm.fundingDetails.cb4xPopin.howToBenefit,
                                  cgu: _vm.fundingDetails.cb4xPopin.cgu,
                                  illustration:
                                    _vm.fundingDetails.cb4xPopin.imageZen,
                                },
                              })
                            : _vm.devicePrice.price
                                .spreadingPrice4xCbWithoutFees
                            ? _c("cb4x-modal-content", {
                                attrs: {
                                  "header-block":
                                    _vm.fundingDetails.cb4xPopin.headerBlock,
                                  "payment-block":
                                    _vm.fundingDetails.cb4xPopin.paymentBlock,
                                  "payment-simulation-block":
                                    _vm.fundingDetails.cb4xPopin
                                      .paymentSimulationBlock,
                                  "how-to-benefit":
                                    _vm.fundingDetails.cb4xPopin.howToBenefit,
                                  faq: _vm.fundingDetails.cb4xPopin.faqBlock,
                                  cgu: _vm.fundingDetails.cb4xPopin.cgu,
                                  "monthly-price":
                                    _vm.devicePrice.price
                                      .spreadingPrice4xCbWithoutFees
                                      .monthlyPrice,
                                  "first-monthly-price":
                                    _vm.devicePrice.price
                                      .spreadingPrice4xCbWithoutFees
                                      .firstMonthlyPrice,
                                  "one-shot-price":
                                    _vm.devicePrice.price
                                      .spreadingPrice4xCbWithoutFees
                                      .oneShotPrice,
                                  illustration:
                                    _vm.fundingDetails.cb4xPopin.imageZen,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.devicePrice.price.pxfAvailable
                  ? {
                      key: "pxf-content",
                      fn: function () {
                        return [
                          _c("pxf-modal-content", {
                            attrs: {
                              "header-block-dto":
                                _vm.fundingDetails.pxfPopin.headerBlockDto,
                              "example-pxf-data":
                                _vm.fundingDetails.pxfPopin.examplePxfData,
                              "example-pxf-tab-subtitle":
                                _vm.fundingDetails.pxfPopin
                                  .examplePxfTabSubtitle,
                              "example-pxf-tab-title":
                                _vm.fundingDetails.pxfPopin.examplePxfTabTitle,
                              "version-pxf-data":
                                _vm.devicePrice.price.versionPxfData,
                              "version-pxf-tab-title":
                                _vm.fundingDetails.pxfPopin.versionPxfTabTitle,
                              "pxf-legal-mentions-text":
                                _vm.fundingDetails.pxfPopin
                                  .pxfLegalMentionsText,
                              illustration:
                                _vm.fundingDetails.pxfPopin.imageZen,
                              "financing-block":
                                _vm.fundingDetails.pxfPopin.financingBlock,
                              cgu: _vm.fundingDetails.pxfPopin.cguDto,
                              "how-to-benefit-dto":
                                _vm.fundingDetails.pxfPopin.howToBenefitDto,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.complementaryPriceLabel
        ? _c("p", {
            staticClass: "pb-0",
            domProps: { innerHTML: _vm._s(_vm.complementaryPriceLabel) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("eco-part-private-copying", {
        attrs: {
          id: "popin-ecopart-modal",
          "eco-part-label":
            _vm.devicePrice.ecoParticipationDTO.ecoParticipationLabel,
          "eco-part-link-label":
            _vm.devicePrice.ecoParticipationDTO.ecoParticipationLinkLabel,
          "eco-part-modal":
            _vm.devicePrice.ecoParticipationDTO.ecoParticipationModal,
          "private-copying-label":
            _vm.devicePrice.ecoParticipationDTO.privateCopyingLabel,
          "private-copying-link":
            _vm.devicePrice.ecoParticipationDTO.privateCopyingLink,
          "private-copying-link-label":
            _vm.devicePrice.ecoParticipationDTO.privateCopyingLinkLabel,
          target:
            _vm.devicePrice.ecoParticipationDTO.ecoParticipationModal.target,
        },
      }),
      _vm._v(" "),
      _vm.showGuaranteeLegalMentions
        ? _c("p", {
            staticClass: "small",
            domProps: { innerHTML: _vm._s(_vm.guaranteeLegalMentionsLabel) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.commitment
        ? _c(
            "section",
            [
              _vm.commitment.withCommitment
                ? _c("p", {
                    staticClass: "pb-0 fw-bold",
                    domProps: { innerHTML: _vm._s(_vm.commitment.text) },
                  })
                : _c("ob1-message-alerte", {
                    attrs: { title: _vm.commitment.text, type: "info" },
                  }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }